import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import styles from './MocaPrompt.module.scss';

const NoteBox = ({ label, placeholder, onSave, onCancel, disabled = false }) => {
  const [note, setNote] = useState('');
  const noteRef = useRef(null);

  useEffect(() => {
    noteRef.current?.focus();
  }, []);

  return (
    <div className={styles.noteBox}>
      <textarea
        ref={noteRef}
        rows={2}
        aria-label={label}
        placeholder={placeholder}
        className={styles.noteInput}
        value={note}
        onChange={(event) => setNote(event.target.value)}
        onKeyDown={(event) => event.stopPropagation()}
      />
      <div className={styles.noteActions}>
        <button
          type="button"
          className={styles.noteButton}
          disabled={disabled || !note.trim()}
          onClick={() => onSave(note.trim())}
        >
          Save
        </button>
        <button type="button" className={styles.ghostButton} onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
};

NoteBox.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default NoteBox;
